import { useMemo } from "react";
import { helpers } from "../../../../../common/lib";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

/**
 * Use Asset-Found-Elsewhere  Data Rules Hook
 * The rules hoooks are defined as per the present scenario
 * These have to change when the  structure of the data  changes
 */

export default () => {
    const {
        typesList,
        auditAssets,
        branches,
        assets,
        assetFoundElsewhere,
        accounts,
        assetAuditors
    } = useSelector((state) => state);

    const params = useParams();

    /** Get current auditAsset  */
    const auditAsset = helpers.getListItemForId(
        auditAssets,
        params.auditAssetId
    );

    const currentAuditAssetId = auditAsset.asset;

    /** Get exclusion Reason */
    const getExclusionReasonName = (reasonId) =>
        typesList.exclusionReasonTypes.data.find(
            (item) => item.id === reasonId
        );

    /** Asset auditor detail
     * 1. Auditor detail
     * 2. Exlcusion reason
     * 3. Note
     */
    const assetAuditedNote = useMemo(() => {
        let detail = {};
        assetAuditors.data.filter((item) => {
            if (item.auditAsset === parseInt(params.auditAssetId)) {
                const auditor = helpers.getListItemForId(
                    accounts,
                    item.auditor
                );
                detail.account = auditor?.displayName || "";
                detail.accountKey =
                    !auditor?.displayName && item.auditor != null
                        ? "userNotFound"
                        : null;

                if (item.exclusionReason) {
                    const exlcusion = getExclusionReasonName(
                        item.exclusionReason
                    );
                    detail.exclusionReason = exlcusion ? exlcusion.name : "";
                }
                if (item.auditNotes.length > 0)
                    detail.note = item.auditNotes[0].content;
                else detail.note = "";
            }
        });
        return detail;
    }, [assetAuditors.data, params.auditAssetId, typesList]);

    /** Get the found elsewhere unexpected ids  */
    const unexpectedAssetIds = useMemo(
        () =>
            assetFoundElsewhere.data[0] &&
            assetFoundElsewhere.data[0].unexpected.map((item) => item.assetId),
        [assetFoundElsewhere.data[0]]
    );

    /** Get unexpected assets from the asset found */
    const assetElsewhere = useMemo(
        () =>
            assetFoundElsewhere.data[0] &&
            assetFoundElsewhere.data[0].unexpected,
        [assetFoundElsewhere.data[0]]
    );

    /** Get current asset */
    const asset = useMemo(
        () =>
            assetElsewhere &&
            assetElsewhere.find((item) => item.assetId === currentAuditAssetId),
        [assetElsewhere, currentAuditAssetId]
    );

    const foundElsewhereData = useMemo(() => {
        if (asset && unexpectedAssetIds.includes(currentAuditAssetId)) {
            /** Get asset detail present */
            const { assetId, branchId, createdBy, createdDate, images } =
                assetElsewhere.find(
                    (item) => item.assetId === currentAuditAssetId
                );
            /** If currentAuditAsset is equal to assetId */
            if (currentAuditAssetId === assetId) {
                const filterBranches = branches.data.find(
                    (item) => item.id === branchId
                );
                const { name } = filterBranches;
                const img = images.map((item) => ({
                    ...item,
                    foundElsewhere: true
                }));
                const foundBy = helpers.getListItemForId(accounts, createdBy);
                return {
                    assetAuditedNote,
                    branchName: name,
                    createdDate: createdDate,
                    foundBy: foundBy?.firstName
                        ? `${foundBy.firstName} ${foundBy.surname || ""}`.trim()
                        : "",
                    foundByKey:
                        !foundBy?.firstName && createdBy != null
                            ? "userNotFound"
                            : null,
                    images: img
                };
            }
        } else return false;
    }, [
        asset,
        assets,
        assetFoundElsewhere,
        unexpectedAssetIds,
        assetElsewhere
    ]);

    return foundElsewhereData;
};
